import React from "react";

export type ServiceItem = {
    id: number;
    img: string;
    subTitle: string;
    detail: string;
};

const ServiceCard = ({ item }: { item: ServiceItem }) => (
    <div className="flex h-full flex-col items-start overflow-hidden rounded-[9.97px] bg-white p-6 shadow-subtle-md outline outline-[1.25px] outline-offset-[-1.25px] outline-slate-200">
        <div className="mb-3 flex w-full items-center gap-3 sm:block">
            <div className="h-8 w-8 shrink-0 overflow-hidden sm:mb-6 sm:h-12 sm:w-12">
                <img src={item.img} className="w-full" alt="" />
            </div>

            <h2 className="whitespace-normal bg-[linear-gradient(25deg,_#FF381D_5%,#3C00D3_90%,_teal)] bg-clip-text text-lead font-semibold text-transparent md:whitespace-pre-line">
                {item.subTitle}
            </h2>
        </div>

        <p className="whitespace-pre-line sm:whitespace-normal text-body font-normal">
            {item.detail}
        </p>
    </div>
);

export default ServiceCard;
